var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcona1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.83 93.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-dasharray: 0 0 10 8;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #eb0028;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        fill: #eb0028;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.97,
    cy: 46.97,
    r: 45.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 92,
    cy: 51.92,
    r: 21.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.97,
    cy: 46.97,
    r: 4.43
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcona1);
export default __webpack_public_path__ + "static/media/Icona_1.62977d775a228d27ef16f5ae814ede53.svg";
export { ForwardRef as ReactComponent };